<div class="lp-inventory" style="width: 100%; height: 100%; display: grid; grid-template-rows: max-content 1fr">
  <div
    class="tabs"
    style="display: grid; grid-auto-flow: column; grid-auto-columns: 1fr; height: max-content"
    [style.display]="disableTabs() ? 'none' : undefined"
  >
    @for (tab of tabs(); track $index) {
      @let _sprite =
        $index === selectedTabIndex() || ($index === 0 && selectedTabIndex() === -1)
          ? _stylesService.INVENTORY_TAB_ACTIVE()
          : _stylesService.INVENTORY_TAB_INACTIVE();
      <app-style-sheet-sprite [sprite]="_sprite?.container" [text]="_sprite?.text" style="cursor: pointer" (click)="selectTab($index)">
        <h2 style="text-align: center; place-content: center">{{ tab.group.name }}</h2>
      </app-style-sheet-sprite>
    }
    @if (!tabs() || tabs()!.length === 0) {
      @let _sprite = _stylesService.INVENTORY_TAB_ACTIVE();
      <app-style-sheet-sprite [sprite]="_sprite?.container" [text]="_sprite?.text" />
    }
  </div>

  @let _itemWidth = 112;
  @let _itemHeight = (_itemWidth / 2) * 2.5;

  <app-style-sheet-sprite [sprite]="_stylesService.INVENTORY_PANEL()?.container" [text]="_stylesService.INVENTORY_PANEL()?.text">
    <div
      class="wrapper"
      style="display: grid; gap: 8px"
      [style.height.px]="3 * _itemHeight"
      [style]="{
        gridTemplateColumns: 'repeat(2, ' + 3 * _itemWidth + 'px)',
      }"
    >
      <div
        class="previews hide-scrollbar"
        style="height: 100%; display: grid; grid-template-columns: repeat(3, 1fr); overflow-y: auto"
        [style.grid-auto-rows.px]="_itemHeight"
        [@stagger]="selectedTabIndex()"
      >
        @if (selectedTab()) {
          @for (item of selectedTab()!.items; track $index) {
            <app-style-sheet-sprite
              [sprite]="
                $index === selectedItemIndex()
                  ? _stylesService.INVENTORY_SLOT_HIGHLIGHTED()?.container
                  : _stylesService.INVENTORY_SLOT()?.container
              "
              [text]="_stylesService.INVENTORY_SLOT()?.text"
              style="display: block; cursor: pointer"
              [style.height.px]="_itemHeight"
              [style.width.px]="_itemWidth"
              (click)="selectedItemIndex.set($index)"
            >
              <lp-inventory-item-preview [name]="item.displayName" [icon]="item.url" style="display: block; height: 100%" />
              @if (enableDebug()) {
                <app-hud-icon-button
                  style="display: block; position: absolute; top: 0em; right: 0em; width: 1.5em; height: 1.5em; z-index: 1"
                  (click)="removeItem.emit(item.index); $event.stopPropagation()"
                />
              }
            </app-style-sheet-sprite>
          }
        }
      </div>
      <div class="content" style="height: inherit">
        <app-style-sheet-sprite [sprite]="_stylesService.INVENTORY_SLOT()?.container" [text]="_stylesService.INVENTORY_SLOT()?.text">
          @let _item = selectedItem();
          @if (_item) {
            <div style="height: 100%; overflow-y: auto" [@modal]="selectedItemIndex()">
              <div
                class="lp-inventory-item-preview"
                style="display: grid; grid-template-rows: max-content 1fr; text-align: center; height: 100%"
              >
                <div>
                  <img [src]="_item.url" style="width: 100%; aspect-ratio: 1; object-fit: contain" />
                </div>
                <h2 style="font-size: 2em; place-content: center">{{ _item.displayName }}</h2>
              </div>

              <lp-inventory-item-content [contents]="_item.contentElements" />
            </div>
          }
        </app-style-sheet-sprite>
      </div>
    </div>
  </app-style-sheet-sprite>
</div>
